<template>

<div class="item">

	<app-view-gallery-field-box_art :field="fieldBox" :item="item" v-if="fieldBox" />

	<component 
        :is="fieldComponent(field)" 
        :item="item" 
        :field="field" 
        :filter="filter" 
        :key="field.id" 
        v-for="field in metricFields" 
    />

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'filter'],

    computed: {

        fieldBox: function() {

            return this.$_.findWhere(this.fields, {
                type: 'box.art'
            })

        },

        metricFields: function() {

            return this.$_.filter(this.fields, function(field) {

                return !field.locked

            })

        }

    },

    methods: {

        fieldComponent: function(field) {

            var component = ['app', 'view', 'gallery', 'field']

            component.push(field.type.replace('.', '_'))

            return component.join('-')

        }

    }

}

</script>

<style scoped>

.item {
    display: flex;
    flex-direction: column;
    align-items: center;
}

</style>